module.exports = __webpack_public_path__ + "media/images/icons/horn-green-349acc28aa1dcb16333efed52c21b461.svg";